import { useEffect, useState } from "react";
import { ReviewStats } from "./components/ReviewStats";
import { TestimonialCard } from "./components/TestimonialCard";
import { TrustedByLogos } from "./components/TrustedByLogos";
import { ROTATION_INTERVAL, testimonials } from "./hooks/useTestimonials";

export const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(current => (current + 1) % testimonials.length);
    }, ROTATION_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="animate-fade-in-slow">
      <div className="space-y-12">
        <TestimonialCard testimonial={testimonials[currentIndex]} />
        <ReviewStats />
      </div>
      <div className="mt-16">
        <TrustedByLogos />
      </div>
    </div>
  );
};
